import {
  ApplicationSubtype,
  AppPageContentWrapper,
  CircularTextLoader,
  PageContentBox,
  THUNK_STATUS,
} from "@duosoftbg/nacid-components";
import { Box } from "@mui/material";
import React, { useEffect } from "react";
import useAppSelector from "../../../../hooks/redux/base/useAppSelector";
import useAppDispatch from "../../../../hooks/redux/base/useAppDispatch";
import { resetSeRecognitionRequest } from "../../../../store/redux/slice/Forms/seRecognitionForm";
import ServiceStepper from "../common/stepper/ServiceStepper";
import { fetchLoggedUserDetails } from "../../../../store/redux/slice/AppData/loggedUser";

const SERecognitionNew = () => {
  const dispatch = useAppDispatch();

  const seRecognitionForm = useAppSelector((state) => {
    return state.Forms.SERecognitionForm;
  });

  useEffect(() => {
    dispatch(resetSeRecognitionRequest());
    dispatch(fetchLoggedUserDetails());
  }, [dispatch]);

  return (
    <AppPageContentWrapper>
      <PageContentBox>
        <Box sx={{ width: "100%" }}>
          {seRecognitionForm.dataStateStatus === THUNK_STATUS.INITIAL ? (
            <ServiceStepper
              serviceSteps={seRecognitionForm.steps}
              applicationSubtype={ApplicationSubtype.SE_RECOGNITION}
            />
          ) : (
            <CircularTextLoader />
          )}
        </Box>
      </PageContentBox>
    </AppPageContentWrapper>
  );
};

export default SERecognitionNew;
